class EventFilter {
  /// <summary>
  /// 滤镜构造函数
  /// </summary>
  constructor()
  constructor(Parameter: string[], StartIndex: number)
  constructor(Parameter: string[] = [], StartIndex: number = 0) {
    if (!Parameter) {
      this.TypeOfFilter = 0
      this.IsCustomImage = 0
      this.OverlayType = 0
      this.Hues = [0, 0, 0, 0, 0]
      this.ImageLayer = new Array<number>()
    } else {
      this.TypeOfFilter = 0
      this.IsCustomImage = 0
      this.OverlayType = 0
      this.Hues = [0, 0, 0, 0, 0]
      this.ImageLayer = new Array<number>()

      if (Parameter.length < StartIndex + 4) return

      let type = parseInt(Parameter[StartIndex])

      if (isNaN(type)) {
        return
      }

      this.TypeOfFilter = type

      switch (this.TypeOfFilter) {
        case FilterType.None:
          break

        case FilterType.Hue:
          this.SetHues(Parameter[StartIndex + 1])
          break

        case FilterType.Overlay:
          this.OverlayType = parseInt(Parameter[StartIndex + 1])
          this.IsCustomImage = parseInt(Parameter[StartIndex + 2])
          this.SetImages(Parameter[StartIndex + 3])
          break

        default:
          break
      }
    }
  }

  /// <summary>
  /// 根据事件构建滤镜
  /// </summary>
  /// <param name="Parameter"></param>
  /// <param name="StartIndex"></param>
  public TypeOfFilter = 0 // 0:无，1:色相，2:叠加效果

  public Hues: number[] = [] // 色相参数

  public OverlayType = 0 // 叠加效果类型 0：正常，1:正片叠底，2:变亮，3:滤色，4:减去，5:饱和度，6:颜色
  public IsCustomImage = 0 // 0：默认，1：自定义图片
  public ImageLayer: number[] = [] // 自定义图片数组，0未选中，1选中

  private SetHues(hues: string) {
    const arr = hues.split(',')
    const length = arr.length > 5 ? 5 : arr.length

    for (let i = 0; i < length; i++) {
      this.Hues[i] = parseInt(arr[i])
    }
  }

  private SetImages(imageData: string) {
    if (!imageData) {
      return
    }
    const images = imageData.split(',')
    //int images_length = images.length > 23 ? 23 : images.length;

    this.ImageLayer = []

    for (let i = 0; i < images.length; i++) {
      this.ImageLayer.push(parseInt(images[i]))
    }
  }

  public SetCurrentLayer(currentLayer: number) {
    const lst = new Array<number>()
    this.ImageLayer.forEach((layer) => {
      if (layer <= currentLayer) {
        lst.push(layer)
      }
    })

    this.ImageLayer = []
    this.ImageLayer.push(...lst)
  }

  public HuesToString() {
    return this.Hues.join(',')
  }

  public ImagesToString() {
    return this.ImageLayer.join(',')
  }

  get FilterTypeMsg() {
    switch (this.TypeOfFilter) {
      case 0:
        return ''
      case 1:
        return '(√色相)'
      case 2:
        return this.OverlayTypeMsg
      default:
        return ''
    }
  }

  get OverlayTypeMsg() {
    //0：正常，1:正片叠底，2:变亮，3:滤色，4:减去，5:饱和度，6:颜色
    switch (this.OverlayType) {
      case 0:
        return '(√正常)'
      case 1:
        return '(√正片叠底)'
      case 2:
        return '(√变亮)'
      case 3:
        return '(√滤色)'
      case 4:
        return '(√减去)'
      case 5:
        return '(√饱和度)'
      case 6:
        return '(√颜色)'
      default:
        return '(√正常)'
    }
  }

  /// <summary>
  /// 转为事件参数
  /// </summary>
  /// <param name="Parameter"></param>
  /// <param name="StartIndex"></param>
  public ToParameter(Parameter: string[], StartIndex: number) {
    //int StartIndex = 13;
    if (Parameter.length < StartIndex + 4) {
      const arrPara: string[] = new Array<string>(StartIndex + 4)
      Parameter.forEach((n, i) => {
        arrPara[i] = n
      })
      Parameter = arrPara
    }

    Parameter[StartIndex] = this.TypeOfFilter.toString()

    switch (this.TypeOfFilter) {
      case FilterType.None:
        Parameter[StartIndex + 1] = ''
        Parameter[StartIndex + 2] = ''
        Parameter[StartIndex + 3] = ''
        break

      case FilterType.Hue:
        Parameter[StartIndex + 1] = this.HuesToString()
        Parameter[StartIndex + 2] = ''
        Parameter[StartIndex + 3] = ''
        break

      case FilterType.Overlay:
        Parameter[StartIndex + 1] = this.OverlayType.toString()
        Parameter[StartIndex + 2] = this.IsCustomImage.toString()
        Parameter[StartIndex + 3] = this.ImagesToString()
        break

      default:
        Parameter[StartIndex + 1] = ''
        Parameter[StartIndex + 2] = ''
        Parameter[StartIndex + 3] = ''
        break
    }

    return Parameter
  }
}
export default EventFilter

enum FilterType {
  None = 0,
  Hue = 1,
  Overlay = 2,
}
